import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const PlacementData = () => {
   const topRef = useRef(null);
  
    const pdfList = [
      { id: 1, title: "Placement Data Batch 2023-2025", src: "/pdf/placement/Placement-data-Batch-2023-2025.pdf", isWeb: false },
      { id: 2, title: "Placement Data Batch 2022-2024", src: "/pdf/placement/Placement-data-Batch-2022-2024-1.pdf", isWeb: false },
      { id: 3, title: "Placement Data Batch 2021-2023", src: "/pdf/placement/Placement-data-Batch-2021-2023-1.pdf", isWeb: false },
      { id: 4, title: "Placement Data Batch 2020-2022", src: "/pdf/placement/Placement-data-Batch-2020-2022.pdf", isWeb: false },
      { id: 5, title: "Placement Data Batch 2019-2022", src: "/pdf/placement/Placement-data-Batch-2019-2022.pdf", isWeb: false },
      { id: 6, title: "Placement Data Batch 2018-2021", src: "/pdf/placement/Placement-data-Batch-2018-2021.pdf", isWeb: false },
      { id: 7, title: "Placement Data Batch 2017-2020", src: "/pdf/placement/Placement-data-Batch-2017-2020.pdf", isWeb: false },
      { id: 8, title: "Placement Data Batch 2016-2017", src: "/pdf/placement/Placement_data_Batch-2016-17.pdf", isWeb: false },
      { id: 9, title: "Placement Data Batch 2015-2016", src: "/pdf/placement/Placement_data_Batch-2015-16.pdf", isWeb: false },
      { id: 10, title: "Placement Data Batch 2014-2015", src: "/pdf/placement/Placement_data_Batch-2014-15.pdf", isWeb: false },
      { id: 11, title: "Placement Data Batch 2013-2014", src: "/pdf/placement/Placement_data_Batch-2013-14.pdf", isWeb: false },
    ];
  
    const [activePdf, setActivePdf] = useState(pdfList[0]);
  
    const handlePdfSelection = (pdf) => {
      if (topRef.current) {
        topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
  
      if (pdf.isWeb) {
        window.open(pdf.src, "_blank");
      } else {
        setActivePdf(pdf);
      }
    };
  
    // Helper to check if the source is a PDF
    const isPdf = (src) => src.toLowerCase().endsWith(".pdf");
  
    return (
      <>
        <Navbar />
        <CTAButton />
  
        <div className="spv-modern-portal">
          <div ref={topRef}>
            <PageHeader 
              title="Placement Data" 
              crumbs={[{ label: 'Home', href: '/' }, { label: 'Placement Data' }]} 
            />
          </div>
  
          <div className="spv-main-content">
            <aside className="spv-sidebar-modern">
              <div className="spv-sidebar-header-text">PLACEMENT DATA</div>
              <nav className="spv-nav-group">
                {pdfList.map((item) => (
                  <button
                    key={item.id}
                    className={`spv-nav-card ${activePdf.id === item.id ? "is-active" : ""}`}
                    onClick={() => handlePdfSelection(item)}
                  >
                    <div className="spv-card-content">
                      <img 
                        src="/images/icons/pdf.svg" 
                        alt="icon" 
                        className="spv-doc-icon-img" 
                      />
                      <span className="spv-card-text">{item.title}</span>
                      <img 
                        src="/images/icons/move.webp" 
                        alt="arrow icon" 
                        className="spv-doc-icon-img" 
                      />
                    </div>
                  </button>
                ))}
              </nav>
            </aside>
  
<main className="spv-viewer-area" key={activePdf.id}>              <header className="spv-viewer-topbar">
                <div className="spv-info-stack">
                  <h2 className="spv-doc-title">{activePdf.title}</h2>
                </div>
                <div className="spv-action-group">
                  <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                    Full Screen
                  </button>
                </div>
              </header>
  
              <div className="spv-pdf-viewport">
                <div className="spv-pdf-card no-select">
                  <iframe
                    src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                    className="spv-iframe-content secure-frame"
                    title="Document Viewer"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              </div>
            </main>
          </div>
        </div>
           
            <Footer />
        </>
    );
};

export default PlacementData;
